<template>
  <div class="root">
    <div class="first">
      <div class="div1">
        1个
      </div>
      <div class="div2">2个</div>
      <div class="div3">100个</div>
      <div class="div4">33万元</div>
    </div>
    <div class="second">
      <ul class="change_ul">
        <li v-for="(item, index) in li_bg" :key="index" @click="changeBg(index)">
          <img :src="index == idx ? item.on : item.off" alt />
        </li>
      </ul>
      <div class="zhuDiv" ref="chart"></div>
    </div>
    <div class="third">
      <div>
        <h3 class="title">成交方式统计</h3>
        <div ref="bing1"></div>
      </div>
      <div>
        <h3 class="title">交易主体统计</h3>
        <div ref="bing2"></div>
      </div>

      <div>
        <h3 class="title">类别统计</h3>
        <div ref="bing3"></div>
      </div>
    </div>

    <h2 class="title1">
      <span></span>
      <p>产权项目交易量</p>
      <span></span>
    </h2>

    <div class="forth">
      <div class="zhexiantu" ref="zhexiantu"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idx: 0,
      li_bg: [
        {
          on: require("../assets/img/数据统计/供应项目0.png"),
          off: require("../assets/img/数据统计/供应项目1.png"),
        },
        {
          on: require("../assets/img/数据统计/需求项目0.png"),
          off: require("../assets/img/数据统计/需求项目1.png"),
        },
        {
          on: require("../assets/img/数据统计/竞价项目0.png"),
          off: require("../assets/img/数据统计/竞价项目1.png"),
        },
        {
          on: require("../assets/img/数据统计/待成交项目0.png"),
          off: require("../assets/img/数据统计/待成交项目1.png"),
        },
        {
          on: require("../assets/img/数据统计/成交项目0.png"),
          off: require("../assets/img/数据统计/成交项目1.png"),
        },
        {
          on: require("../assets/img/数据统计/成交金额0.png"),
          off: require("../assets/img/数据统计/成交金额1.png"),
        },
      ],
    };
  },
  created() { },
  mounted() {
    this.initCharts();

    this.bingTu1();
    this.bingTu2();
    this.bingTu3();
    this.zhexiantu();
  },
  computed: {},
  watch: {},
  methods: {
    changeBg(index) {
      this.idx = index;
    },

    // 柱状图
    initCharts() {
      // console.log("调用了");
      let chart = this.$echarts.init(this.$refs.chart);
      // 绘制图表
      chart.setOption({

        color: ["#1798FF"],
        dataset: {
          source: [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            [
              0.25,
              0.36,
              0.14,
              0.28,
              0.36,
              0.91,
              0.25,
              0.36,
              0.14,
              0.28,
              0.36,
              0.91,
            ],
          ],
        },

        xAxis: {
          type: "category",
          name: "月",
          nameTextStyle: {
            color: "#333333",
            fontWeight: "400",
            fontSize: 30,
            padding: [0, 0, 0, 5],
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            show: true,
            textStyle: {
              color: "#333333", //更改坐标轴文字颜色
              fontSize: 30, //更改坐标轴文字大小
            },
          },
        },

        yAxis: {
          splitLine: {
            show: true, //不显示网格线
          },
          type: "value",
          name: "单位：个/万元",
          nameTextStyle: {
            color: "#333333",
            fontWeight: "400",
            fontSize: 30,
            padding: [0, 0, 0, 5],
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333333", //更改坐标轴文字颜色
              fontSize: 30, //更改坐标轴文字大小
            },
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },

        series: [
          {
            type: "bar",
            seriesLayoutBy: "row",
            itemStyle: {
              // barBorderRadius: [14, 14, 0, 0],
            },
            barWidth: "24",
            barGap: "82%",
          },
        ],
      });
    },

    // 饼1
    bingTu1() {
      // console.log("调用了");
      let chart = this.$echarts.init(this.$refs.bing1);
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "1%",
          left: "center",
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "70%"],
            avoidLabelOverlap: false,
            color: ["#407FFF", "#F29961", "#E15D68"],
            label: {
              show: false,
              position: "inner",
              fontSize: 12,
              align: "left",
              formatter: function (p) {
                //指示线对应文字,百分比
                return p.percent.toFixed(0) + "%"; //设置百分比保留几位小数
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "bold",
                color: "#FFFFFF",
              },
            },
            labelLine: {
              show: false,
            },
            data: [{ value: 1048, name: "进场结算" }],
          },
        ],
      });
    },

    // 饼2
    bingTu2() {
      // console.log("调用了");
      let chart = this.$echarts.init(this.$refs.bing2);
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "1%",
          left: "center",
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "70%"],
            avoidLabelOverlap: false,
            color: ["#F29961", "#407FFF", "#E15D68"],
            label: {
              show: false,
              position: "inner",
              fontSize: 12,
              align: "left",
              formatter: function (p) {
                //指示线对应文字,百分比
                return p.percent.toFixed(0) + "%"; //设置百分比保留几位小数
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "bold",
                color: "#FFFFFF",
              },
            },
            labelLine: {
              show: false,
            },
            data: [{ value: 100, name: "法人单位" }],
          },
        ],
      });
    },

    // 饼3
    bingTu3() {
      // console.log("调用了");
      let chart = this.$echarts.init(this.$refs.bing3);
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "1%",
          left: "center",
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "70%"],
            avoidLabelOverlap: false,
            color: ["#F29961", "#407FFF", "#E15D68"],
            label: {
              show: false,
              position: "inner",
              fontSize: 12,
              align: "left",
              formatter: function (p) {
                //指示线对应文字,百分比
                return p.percent.toFixed(0) + "%"; //设置百分比保留几位小数
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "bold",
                color: "#FFFFFF",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 50, name: "农村承包土地经营权" },
              { value: 30, name: "农村集体资源性资产" },
              { value: 20, name: "林权" },
            ],
          },
        ],
      });
    },

    // 折线图
    zhexiantu() {
      // console.log("调用了");
      let chart = this.$echarts.init(this.$refs.zhexiantu);
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: "category",
          data: [
            "道口镇街道",
            "城关街道",
            "锦和街道",
            "白道口镇",
            "留固镇",
            "上官镇",
            "牛屯镇",
            "万古镇",
            "高平镇",
            "王庄镇",
            "老店镇",
            "慈周寨镇",
            "焦虎镇",
            "四间房镇",
            "枣村乡",
            "八里营乡",
            "赵营乡",
            "大寨乡",
            "桑村乡",
            "老爷庙乡",
            "瓦岗寨乡",
            "半坡店乡",
            "小铺乡",
          ],
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              color: "#333333", //更改坐标轴文字颜色
              fontSize: 20, //更改坐标轴文字大小
            },
          },
        },
        yAxis: {
          splitLine: {
            show: true, //不显示网格线
          },
          type: "value",
          name: "数量",
          nameTextStyle: {
            color: "#333333",
            fontWeight: "400",
            fontSize: 30,
            padding: [0, 0, 0, 5],
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333333", //更改坐标轴文字颜色
              fontSize: 30, //更改坐标轴文字大小
            },
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 150, 230, 224, 218, 260, 150, 230, 224, 218, 135, 147, 150, 230, 224, 218, 260, 150],
            type: "line",
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  textStyle: {
                    color: "#666666",
                    fontSize: 22,
                  },
                },
                lineStyle: {
                  color: "#509DE0", //折线的颜色
                },
              },
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.root {
  min-height: 1180px;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.root>div {
  width: 1500px;
  margin: 0 auto;
}

.root .first {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 40px auto;
}

.first>div {
  width: 350px;
  height: 188px;
  background-color: aqua;
  border-radius: 10px;
  background-size: 100% 100%;
  line-height: 230px;
  color: white;
  text-align: center;
}

/* .first > div span{
    color: white;
    width: 350px;
    line-height: 230px;
    text-align: center;
    height: 100%;
} */
.div1 {
  background: url("../assets/img/数据统计/供应项目背景.png") no-repeat;
}

.div2 {
  background: url("../assets/img/数据统计/需求项目背景.png") no-repeat;
}

.div3 {
  background: url("../assets/img/数据统计/成交项目背景.png") no-repeat;
}

.div4 {
  background: url("../assets/img/数据统计/成交金额背景.png") no-repeat;
}

.second {
  width: 1500px;
  height: 804px;
  background: #ffffff;
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.change_ul {
  list-style: inside none;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  padding: 0 30px;
  margin: 30px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  overflow: hidden;
}

.change_ul li {
  cursor: pointer;
  width: auto;
  height: 50px;
}

.change_ul li img {
  display: block;
  cursor: pointer;
  width: auto;
  height: 50px;
}

.zhuDiv {
  width: 98%;
  height: 700px;
}

.root .third {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 40px auto;
}

.third>div {
  width: 480px;
  height: 320px;
  box-sizing: border-box;
  padding: 23px;
  background-color: #ffffff;
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.title {
  width: auto;
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  line-height: 30px;
  font-weight: 400;
  color: #333333;
}

.third>div>div {
  margin: 0 auto;
  width: 100%;
  height: 250px;
}

.title1 {
  width: 100%;

  height: 38px;
  font-size: 38px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 38px;

  color: #333333;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.title1 p {
  padding: 0 20px;
}

.title1 span {
  display: block;
  width: 68px;
  height: 2px;
  background: #509de0;
}

.root .forth {
  width: 1500px;
  height: 732px;
  background: #ffffff;
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.1);
  margin-top: 40px;
  margin-bottom: 100px;
  overflow: hidden;
}

.zhexiantu {
  width: 100%;
  height: 90%;
}</style>
